import { motion } from 'framer-motion'
import ContactForm   from '../components/contact/ContactForm'
import ContactInfo   from '../components/contact/ContactInfo'
import { BalloonLayer } from '../components/ui/BalloonSVG'

export default function Contact() {
  return (
    <>
      {/* ── Hero ─────────────────────────────────────────────────────────── */}
      <section
        className="relative pt-32 pb-20 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #FF6BB5 0%, #7C3AFF 100%)' }}
      >
        <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-white/10 rounded-full blur-3xl pointer-events-none" />
        <BalloonLayer opacity={0.28} />

        <div className="container-custom relative z-10 text-center">
          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 mb-5 px-5 py-2 rounded-full bg-white/20 border border-white/30 text-white text-sm font-body font-bold tracking-widest uppercase backdrop-blur-sm"
          >
            📩 Contact Us
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="font-display text-5xl md:text-6xl text-white mb-6"
          >
            Book Your Party
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="font-body text-white/80 text-lg max-w-xl mx-auto"
          >
            Let's start planning your child's magical day
          </motion.p>
        </div>
      </section>

      {/* ── Split layout: form + info ─────────────────────────────────────── */}
      <section className="section-padding bg-gradient-to-b from-background to-surface">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Form first on desktop */}
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </section>

      {/* ── Map placeholder ───────────────────────────────────────────────── */}
      <section className="h-64 bg-primary/5 flex items-center justify-center border-t border-primary-100">
        <div className="text-center">
          <p className="text-4xl mb-3">🗺️</p>
          <p className="font-display text-ink text-lg">Cairo, Egypt</p>
          <p className="font-body text-ink-muted text-sm mt-1">
            Embed your Google Maps iframe here
          </p>
        </div>
      </section>
    </>
  )
}
